import React from 'react';
import { signingService } from '../../services/api';

const EnvelopeStatusBadge = ({ status }) => {
  const colorClasses = {
    draft: 'bg-gray-100 text-gray-800',
    sent: 'bg-blue-100 text-blue-800',
    viewed: 'bg-yellow-100 text-yellow-800',
    partially_signed: 'bg-orange-100 text-orange-800',
    completed: 'bg-green-100 text-green-800',
    declined: 'bg-red-100 text-red-800',
    expired: 'bg-gray-100 text-gray-600',
    voided: 'bg-red-100 text-red-800',
  };

  const label = signingService.getStatusLabel(status);
  const colorClass = colorClasses[status] || 'bg-gray-100 text-gray-800';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
      {label}
    </span>
  );
};

export default EnvelopeStatusBadge;
